import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { CarrinhoService } from '../../../core/services/carrinho.service';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, FormsModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  authService = inject(AuthService);
  carrinhoService = inject(CarrinhoService);
  themeService = inject(ThemeService);
  private router = inject(Router);

  termoBusca = '';
  mobileMenuOpen = false;

  logout(): void {
    this.authService.logout().subscribe();
  }

  buscarMedicamento(): void {
    // Redirecionar para registro se não estiver logado
    if (this.termoBusca && this.termoBusca.trim()) {
      this.router.navigate(['/registro'], {
        queryParams: { redirect: 'busca' }
      });
      this.mobileMenuOpen = false;
    }
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }
}
